{
  "common": {
    "save": "Simpan",
    "save_changes": "Simpan Perubahan",
    "cancel": "Batal",
    "delete": "Hapus",
    "edit": "Edit",
    "view": "Lihat",
    "create": "Buat",
    "search": "Cari",
    "back": "Kembali",
    "add": "Tambah",
    "remove": "Hapus",
    "submit": "Kirim",
    "confirm": "Konfirmasi",
    "close": "Tutup",
    "done": "Selesai",
    "next": "Berikutnya",
    "previous": "Sebelumnya",
    "loading": "Memuat…",
    "no_data": "Belum ada data",
    "not_found": "Tidak ditemukan",
    "required": "Wajib",
    "optional": "Opsional",
    "all": "Semua",
    "new": "Baru",
    "yes": "Ya",
    "no": "Tidak",
    "logout": "Keluar",
    "actions": "Aksi",
    "status": "Status",
    "total": "Total",
    "filter": "Filter",
    "today": "Hari ini",
    "days": "hari",
    "hours": "jam",
    "months": "bln",
    "success": "Berhasil",
    "updated": "Diperbarui",
    "failed": "Gagal",
    "error": "Gagal",
    "try_again": "Silakan coba lagi",
    "err_validation": "Mohon periksa kolom yang disorot",
    "err_unauthorized": "Sesi Anda telah habis — silakan masuk kembali",
    "err_forbidden": "Anda tidak memiliki izin untuk melakukan itu",
    "err_not_found": "Data yang dicari tidak ditemukan",
    "err_conflict": "Data tersebut bentrok dengan data yang sudah ada",
    "err_network": "Masalah jaringan — periksa koneksi Anda lalu coba lagi",
    "err_berth_overlap": "Dermaga itu sudah dipesan untuk tanggal tersebut",
    "err_negative_stock": "Stok tidak bisa kurang dari nol",
    "err_has_relations": "Hapus data terkait terlebih dahulu, lalu coba lagi",
    "err_invalid_state": "Tindakan itu tidak tersedia di status saat ini",
    "err_generic": "Terjadi masalah di sisi kami. Silakan coba lagi.",
    "see_more": "Lihat →",
    "draft": "Draf",
    "send": "Kirim",
    "notes": "Catatan",
    "name": "Nama",
    "email": "Email",
    "phone": "Telepon",
    "country": "Negara",
    "showing": "{{first}}–{{last}} dari {{total}} data"
  },
  "nav": {
    "overview": "Ikhtisar",
    "analytics": "Analitik",
    "dermaga": "Dermaga",
    "map": "Peta",
    "schedule": "Jadwal",
    "absences": "Absen",
    "arrivals": "Tiba & Berangkat",
    "tambat": "Tambat",
    "requests": "Permohonan",
    "bookings": "Booking",
    "billing": "Penagihan",
    "quotes": "Penawaran",
    "invoices": "Faktur",
    "directory": "Direktori",
    "customers": "Pelanggan",
    "boats": "Kapal",
    "contracts": "Kontrak",
    "logistics": "Logistik",
    "tasks": "Tugas",
    "inventory": "Inventaris",
    "utilities": "Utilitas",
    "settings": "Pengaturan",
    "dev_console": "Dev Console",
    "section": {
      "Operasional": "Operasional",
      "Keuangan": "Keuangan",
      "Manajemen": "Manajemen",
      "Sistem": "Sistem"
    }
  },
  "auth": {
    "profile": "Profil Saya",
    "light_mode": "Mode Terang",
    "dark_mode": "Mode Gelap",
    "logout": "Keluar",
    "logout_title": "Keluar",
    "logout_msg": "Anda yakin ingin keluar dari sesi ini?",
    "expand_sidebar": "Perluas sidebar",
    "collapse_sidebar": "Tutup sidebar",
    "lang_switched_en": "Bahasa diubah ke Inggris",
    "lang_switched_en_msg": "Antarmuka Bahasa Inggris segera hadir.",
    "lang_switched_id": "Bahasa diubah ke Indonesia",
    "lang_switched_id_msg": "Antarmuka penuh Bahasa Indonesia tersedia.",
    "switch_to_en": "🇬🇧 Switch to English",
    "switch_to_id": "🇮🇩 Ganti ke Bahasa Indonesia",
    "role": {
      "SUPER_ADMIN": "Super Admin",
      "MANAGER": "Manajer",
      "STAFF": "Staf",
      "VIEWER": "Pengamat",
      "CUSTOMER": "Pelanggan",
      "default": "Pengguna"
    }
  },
  "status": {
    "booking": {
      "PENDING": "Menunggu",
      "WAITLISTED": "Daftar tunggu",
      "CONFIRMED": "Dikonfirmasi",
      "DECLINED": "Ditolak",
      "RESERVED": "Dipesan",
      "CHECKED_IN": "Berlabuh",
      "CHECKED_OUT": "Berlayar",
      "CANCELLED": "Dibatalkan",
      "NO_SHOW": "Tidak hadir"
    },
    "contract": {
      "DRAFT": "Konsep",
      "PREPARED": "Siap",
      "PENDING_REVIEW": "Sedang ditinjau",
      "ACTIVE": "Aktif",
      "EXPIRED": "Kedaluwarsa",
      "TERMINATED": "Diakhiri"
    },
    "quote": {
      "DRAFT": "Konsep",
      "SENT": "Terkirim",
      "ACCEPTED": "Diterima",
      "REJECTED": "Ditolak",
      "EXPIRED": "Kedaluwarsa",
      "CONVERTED": "Jadi tagihan"
    },
    "invoice": {
      "PRO_FORMA": "Pro forma",
      "DRAFT": "Konsep",
      "SENT": "Terkirim",
      "PARTIALLY_PAID": "Sebagian lunas",
      "PAID": "Lunas",
      "OVERDUE": "Lewat tenggat",
      "CANCELLED": "Dibatalkan"
    },
    "berth": {
      "AVAILABLE": "Tersedia",
      "OCCUPIED": "Terisi",
      "RESERVED": "Dipesan",
      "MAINTENANCE": "Pemeliharaan",
      "BLOCKED": "Tidak tersedia"
    },
    "assignmentStatus": {
      "PENDING": "Belum dimulai",
      "IN_PROGRESS": "Sedang dikerjakan",
      "COMPLETED": "Selesai",
      "BLOCKED": "Terhambat",
      "CANCELLED": "Dibatalkan"
    },
    "assignmentPriority": {
      "LOW": "Rendah",
      "MEDIUM": "Sedang",
      "HIGH": "Tinggi",
      "URGENT": "Mendesak"
    },
    "customerCategory": {
      "TRANSIT": "Transit",
      "OWNER": "Pemilik",
      "RENTER": "Penyewa",
      "MEMBER": "Anggota",
      "GUEST": "Tamu",
      "OTHER": "Lainnya"
    },
    "inventoryThreshold": {
      "OUT": "Stok habis",
      "LOW": "Stok menipis",
      "GOOD": "Stok cukup"
    }
  },
  "palette": {
    "trigger": "Cari cepat",
    "placeholder": "Cari apa saja — pelanggan, kapal, booking, faktur…",
    "empty": "Tidak ada hasil",
    "empty_hint": "Coba nama pelanggan, nama kapal, atau nomor faktur",
    "shortcut_hint": "Buka cari cepat",
    "group_actions": "Aksi cepat",
    "group_pages": "Buka",
    "group_customers": "Pelanggan",
    "group_boats": "Kapal",
    "group_bookings": "Booking",
    "group_invoices": "Faktur",
    "group_quotes": "Penawaran",
    "group_contracts": "Kontrak",
    "action_new_booking": "Booking baru",
    "action_new_customer": "Pelanggan baru",
    "action_new_boat": "Kapal baru",
    "action_new_quote": "Penawaran baru",
    "action_new_invoice": "Faktur baru",
    "action_new_contract": "Kontrak baru",
    "action_new_assignment": "Tugas baru",
    "action_new_inventory": "Item inventaris baru",
    "footer_navigate": "untuk navigasi",
    "footer_select": "untuk buka",
    "footer_close": "untuk tutup",
    "searching": "Mencari…"
  },
  "page": {
    "overview": {
      "title": "Ikhtisar",
      "subtitle": "Kondisi marina Anda hari ini",
      "free_berths": "Berth Tersedia",
      "occupied_berths": "Berth Terisi",
      "revenue_month": "Pendapatan Bulan Ini",
      "pending_requests": "Permintaan Pending",
      "create_booking": "Buat Booking",
      "empty_requests_title": "Semua jelas",
      "empty_requests_desc": "Tidak ada permintaan tertunda.",
      "empty_bookings_title": "Dermaga sunyi",
      "empty_bookings_desc": "Booking terbaru akan muncul di sini.",
      "insight_pending_title": "Permintaan menunggu",
      "insight_pending_sub_plural": "{{n}} booking perlu keputusan",
      "insight_pending_sub_one": "{{n}} booking perlu keputusan",
      "insight_pending_cta": "Tinjau sekarang",
      "insight_pending_empty": "Kotak masuk bersih",
      "insight_overdue_title": "Faktur lewat tenggat",
      "insight_overdue_sub_plural": "{{n}} pelanggan · {{amount}} belum dibayar",
      "insight_overdue_sub_one": "{{n}} pelanggan · {{amount}} belum dibayar",
      "insight_overdue_cta": "Tagih sekarang",
      "insight_overdue_empty": "Semua faktur lancar",
      "insight_late_title": "Telat check-out",
      "insight_late_sub_plural": "{{n}} kapal lewat jam keberangkatan",
      "insight_late_sub_one": "{{n}} kapal lewat jam keberangkatan",
      "insight_late_cta": "Check out sekarang",
      "insight_late_empty": "Semua check-out tepat waktu",
      "insight_today_title": "Hari ini",
      "insight_today_sub": "{{arrivals}} datang · {{departures}} berangkat",
      "insight_today_cta": "Lihat jadwal",
      "insight_revenue_title": "Pendapatan bulan ini",
      "insight_revenue_mom_up": "↑ {{n}}% vs bulan lalu",
      "insight_revenue_mom_down": "↓ {{n}}% vs bulan lalu",
      "insight_revenue_mom_flat": "Sama dengan bulan lalu",
      "insight_revenue_mom_none": "Bulan pertama aktivitas",
      "insight_revenue_cta": "Lihat rincian",
      "insight_expiring_title": "Kontrak hampir berakhir",
      "insight_expiring_sub_plural": "{{n}} kontrak berakhir dalam 30 hari",
      "insight_expiring_sub_one": "{{n}} kontrak berakhir dalam 30 hari",
      "insight_expiring_cta": "Tinjau perpanjangan",
      "insight_expiring_empty": "Tidak ada kontrak akan berakhir",
      "insight_late_detail": "{{customer}} dengan {{boat}} · telat {{hours}}j",
      "minutes_short": "mnt",
      "hours_short": "j"
    },
    "analytics": {
      "title": "Analitik Marina",
      "subtitle": "Ringkasan performa, armada, pelanggan & keuangan",
      "tab_fleet": "Armada",
      "tab_boat_docs": "Dok. Kapal",
      "tab_id_docs": "Dok. ID",
      "tab_customers": "Pelanggan",
      "tab_revenue": "Pendapatan"
    },
    "occupancy": {
      "map": {
        "title": "Peta Berth",
        "stat_available": "Tersedia",
        "stat_occupied": "Terisi",
        "stat_reserved": "Dipesan",
        "stat_maintenance": "Maintenance",
        "btn_edit": "Edit Layout",
        "btn_done": "Selesai",
        "btn_cancel": "Batal",
        "unsaved": "{{n}} belum tersimpan",
        "saving": "Menyimpan…",
        "placeholder_berth": "Cari berth…",
        "placeholder_pontoon": "Semua pontoon"
      },
      "calendar": {
        "title": "Jadwal Tambat",
        "btn_new": "+ Buat Permintaan",
        "btn_today": "Kembali ke hari ini",
        "count_berths": "Berth ditampilkan",
        "count_bookings": "Tambat dalam periode",
        "count_boats": "Kapal unik",
        "placeholder_pontoon": "Semua pontoon"
      },
      "absences": {
        "title": "Absen",
        "subtitle": "Berth yang ditinggalkan sementara oleh pelanggan",
        "stat_total": "Total absensi",
        "stat_avg": "Rata-rata durasi",
        "stat_berths": "Berth unik",
        "tab_available": "Tersedia Subsewa",
        "tab_blocked": "Diblokir",
        "hint_available": "Berth yang kosong sementara dan tersedia untuk disewa.",
        "hint_blocked": "Berth yang dikosongkan namun tetap diblokir.",
        "col_customer": "Pelanggan",
        "col_berth": "Berth",
        "col_period": "Periode Absen",
        "col_duration": "Durasi",
        "col_reason": "Alasan",
        "col_status": "Status",
        "col_booking": "Booking",
        "empty_available": "Belum ada berth yang ditandai tersedia untuk subsewa",
        "empty_blocked": "Belum ada berth yang diblokir sementara"
      },
      "arrivals": {
        "title": "Tiba & Berangkat",
        "stat_arrivals": "Kedatangan",
        "stat_departures": "Keberangkatan",
        "stat_recorded": "Tercatat aktual",
        "stat_late": "Terlambat > 30m",
        "tab_all": "Semua",
        "tab_arrivals": "Kedatangan",
        "tab_departures": "Keberangkatan",
        "placeholder": "Cari kapal, pelanggan, berth…",
        "tooltip_arrival": "Kedatangan",
        "tooltip_departure": "Keberangkatan",
        "no_results": "Tidak ada hasil untuk \"{{q}}\""
      }
    },
    "reservations": {
      "requests": {
        "title": "Permohonan",
        "subtitle": "Permohonan tambat masuk yang perlu ditinjau & disetujui",
        "btn_new": "+ Booking Baru",
        "alert_pending": "{{n}} menunggu persetujuan",
        "alert_waitlisted": "{{n}} dalam daftar tunggu",
        "tab_all": "Semua",
        "tab_pending": "Menunggu",
        "tab_waitlisted": "Daftar Tunggu",
        "tab_confirmed": "Dikonfirmasi",
        "tab_declined": "Ditolak",
        "placeholder": "Cari pelanggan, kapal, kode…"
      },
      "bookings": {
        "title": "Booking Aktif",
        "subtitle": "Booking yang sudah dikonfirmasi — dipesan, berlabuh, selesai",
        "btn_new": "+ Buat Permintaan",
        "stat_in_marina": "Sedang berlabuh",
        "stat_reserved": "Menunggu check-in",
        "stat_completed": "Selesai (all-time)",
        "tab_all": "Semua",
        "tab_reserved": "Dipesan",
        "tab_in": "Di Marina",
        "tab_out": "Selesai",
        "tab_cancelled": "Dibatalkan",
        "placeholder": "Cari pelanggan, kapal, kode…"
      },
      "detail": {
        "title": "Detail Booking",
        "subtitle": "Reservasi {{code}}",
        "not_found": "Booking tidak ditemukan",
        "back_link": "← Kembali ke daftar booking",
        "section_customer": "Pelanggan",
        "section_boat": "Kapal",
        "section_berth": "Berth & Saluran",
        "section_timeline": "Alur Booking",
        "section_documents": "Dokumen Terkait",
        "field_name": "Nama",
        "field_email": "Email",
        "field_phone": "Telepon",
        "field_country": "Negara",
        "field_boat_name": "Nama",
        "field_type": "Tipe",
        "field_loa": "LOA",
        "field_flag": "Bendera",
        "field_berth": "Berth",
        "field_pontoon": "Pontoon",
        "field_channel": "Saluran",
        "field_location": "Lokasi",
        "notes_label": "Catatan",
        "timeline_created": "Dibuat",
        "timeline_confirmed": "Dikonfirmasi",
        "timeline_berth": "Berth Ditetapkan",
        "timeline_checkin": "Check-in",
        "timeline_checkout": "Check-out",
        "timeline_planned": "{{date}} (rencana)",
        "action_approve": "Setujui",
        "action_waitlist": "Daftar Tunggu",
        "action_assign": "Tetapkan Berth",
        "action_checkin": "Check-in",
        "action_checkout": "Check-out",
        "action_decline": "Tolak",
        "action_cancel": "Batalkan",
        "confirm_approve": "Setujui booking {{code}}?",
        "confirm_waitlist": "Pindahkan {{code}} ke daftar tunggu?",
        "confirm_checkin": "Konfirmasi check-in {{code}} sekarang?",
        "confirm_checkout": "Konfirmasi check-out {{code}} sekarang?",
        "confirm_cancel": "Batalkan booking {{code}}?",
        "notify_approved": "Booking disetujui",
        "notify_waitlisted": "Dipindahkan ke daftar tunggu",
        "notify_checkin": "Check-in dicatat",
        "notify_checkout": "Check-out dicatat",
        "notify_cancelled": "Booking dibatalkan",
        "modal_assign_title": "Tetapkan Berth — {{code}}",
        "modal_assign_desc": "Pilih berth yang tersedia. Tumpang tindih tanggal dicek saat disimpan.",
        "modal_assign_placeholder": "Pilih berth yang tersedia…",
        "modal_assign_btn": "Tetapkan",
        "modal_decline_title": "Tolak Permintaan",
        "modal_decline_label": "Alasan Penolakan",
        "modal_decline_placeholder": "Jelaskan alasan penolakan booking ini kepada pelanggan…",
        "modal_decline_btn": "Tolak Permintaan",
        "terminal_declined": "Booking ditolak.",
        "terminal_cancelled": "Booking dibatalkan.",
        "terminal_noshow": "Tidak hadir (no-show)."
      }
    },
    "billing": {
      "quotes": {
        "title": "Penawaran",
        "subtitle": "Penawaran harga layanan marina untuk pelanggan",
        "btn_new": "+ Buat Penawaran",
        "placeholder": "Cari penawaran…",
        "col_code": "No. Penawaran",
        "col_customer": "Pelanggan",
        "col_total": "Total",
        "col_valid": "Berlaku Sampai",
        "col_status": "Status",
        "col_actions": "Aksi",
        "tab_all": "Semua",
        "tab_draft": "Draf",
        "tab_sent": "Terkirim",
        "tab_accepted": "Diterima",
        "tab_rejected": "Ditolak",
        "tab_expired": "Kadaluwarsa",
        "tab_converted": "Dikonversi",
        "alert_accepted": "{{n}} penawaran diterima — siap dikonversi ke faktur",
        "alert_expired": "{{n}} penawaran kadaluwarsa — perlu tindak lanjut",
        "empty": "Belum ada penawaran",
        "empty_accepted": "Belum ada penawaran yang diterima",
        "empty_expired": "Tidak ada penawaran kadaluwarsa",
        "days_left": "{{n}} hari lagi",
        "days_ago": "{{n}} hari lalu",
        "today": "Hari ini",
        "detail": {
          "loading": "Memuat penawaran…",
          "not_found": "Penawaran tidak ditemukan",
          "linked_invoice": "Faktur terkait",
          "action_send": "Kirim ke pelanggan",
          "action_send_title": "Kirim penawaran ini?",
          "action_send_body": "Pelanggan akan menerima email berisi detail penawaran. Nomor referensi akan dikunci.",
          "action_accept": "Tandai diterima",
          "action_accept_title": "Tandai penawaran sebagai diterima?",
          "action_accept_body": "Memastikan pelanggan menyetujui penawaran ini. Anda bisa membuat faktur darinya setelah ini.",
          "action_reject": "Tandai ditolak",
          "action_reject_title": "Tandai penawaran sebagai ditolak?",
          "action_reject_body": "Bisa dibalik — Anda dapat mengirim ulang penawaran nanti jika pelanggan berubah pikiran.",
          "action_convert": "Buat faktur",
          "convert_modal_title": "Buat faktur dari penawaran ini",
          "convert_modal_body": "Faktur konsep akan dibuat dengan baris item yang sama. Pelanggan tidak ditagih sampai Anda mengirimkannya.",
          "convert_modal_due": "Tanggal jatuh tempo",
          "convert_modal_submit": "Buat faktur"
        }
      },
      "invoices": {
        "title": "Faktur",
        "subtitle": "Penagihan dan pembayaran pelanggan marina",
        "btn_new": "+ Buat Faktur",
        "placeholder": "Cari faktur…",
        "col_code": "No. Faktur",
        "col_customer": "Pelanggan",
        "col_total": "Total",
        "col_due": "Jatuh Tempo",
        "col_status": "Status",
        "col_actions": "Aksi",
        "tab_all": "Semua",
        "tab_draft": "Draf",
        "tab_sent": "Terkirim",
        "tab_partial": "Sebagian",
        "tab_paid": "Lunas",
        "tab_overdue": "Jatuh Tempo",
        "tab_cancelled": "Dibatalkan",
        "alert_overdue": "{{n}} faktur jatuh tempo — segera tagih",
        "empty": "Belum ada faktur",
        "empty_overdue": "Tidak ada faktur jatuh tempo",
        "detail": {
          "loading": "Memuat faktur…",
          "not_found": "Faktur tidak ditemukan",
          "linked_quote": "Dari penawaran",
          "linked_booking": "Dari booking",
          "action_finalize": "Konfirmasi konsep",
          "action_finalize_title": "Konfirmasi konsep ini?",
          "action_finalize_body": "Mengunci baris item agar faktur dapat dikirim. Anda masih dapat membatalkan atau merefund nanti.",
          "action_send": "Kirim ke pelanggan",
          "action_send_title": "Kirim faktur ini?",
          "action_send_body": "Pelanggan akan menerima email berisi faktur dan instruksi pembayaran.",
          "action_record_payment": "Catat pembayaran",
          "action_void": "Batalkan faktur",
          "action_void_title": "Batalkan faktur ini?",
          "action_void_body": "Faktur tetap tersimpan untuk arsip tapi tidak lagi terhitung sebagai tagihan. Hanya dapat dipulihkan oleh tim dukungan.",
          "payment_modal_title": "Catat pembayaran",
          "payment_modal_amount": "Jumlah diterima",
          "payment_modal_method": "Metode pembayaran",
          "payment_modal_reference": "Referensi (opsional)",
          "payment_modal_submit": "Simpan pembayaran"
        }
      },
      "quote_new": {
        "title": "Buat Penawaran",
        "subtitle": "Isi semua bagian lalu simpan sebagai Draf atau kirim langsung ke pelanggan",
        "step_customer": "Pelanggan",
        "step_boat": "Kapal",
        "step_details": "Detail Penawaran",
        "step_items": "Item Layanan",
        "label_customer": "Pilih Pelanggan",
        "label_boat": "Kapal Pelanggan",
        "placeholder_customer": "Cari nama atau email pelanggan…",
        "placeholder_boat_no_customer": "Pilih pelanggan dulu",
        "placeholder_boat_empty": "Pelanggan belum punya kapal",
        "placeholder_boat": "Pilih kapal…",
        "boat_optional": "(Opsional)",
        "boat_no_customer_hint": "Pilih pelanggan dulu untuk memilih kapal.",
        "detail_title": "Detail Penawaran",
        "detail_subtitle": "Periode berlaku, tarif pajak, dan catatan penawaran.",
        "valid_until": "Berlaku Sampai",
        "valid_days_from_now": "Berlaku {{n}} hari lagi · {{date}}",
        "valid_today": "Berlaku hari ini · {{date}}",
        "valid_expired": "Sudah kedaluwarsa · {{date}}",
        "tax_rate": "Tarif Pajak (%)",
        "tax_free": "0% — Bebas Pajak",
        "tax_ppn": "11% — PPN",
        "notes_label": "Catatan (opsional)",
        "notes_desc": "Syarat, ketentuan, atau pesan khusus untuk pelanggan",
        "notes_placeholder": "Contoh: Harga berlaku untuk pembayaran sebelum jatuh tempo...",
        "items_title": "Item Layanan",
        "items_subtitle": "Layanan dan produk yang ditawarkan dalam penawaran ini.",
        "items_hint": "Tambahkan minimal satu item dengan harga untuk bisa menyimpan penawaran.",
        "review_title": "Tinjau & Kirim",
        "review_subtitle": "Periksa semua detail sebelum membuat.",
        "summary_title": "Ringkasan Penawaran",
        "field_customer": "Pelanggan",
        "field_boat": "Kapal",
        "field_valid": "Berlaku Sampai",
        "field_tax": "Tarif Pajak",
        "no_customer": "— belum dipilih",
        "subtotal": "Subtotal",
        "tax": "PPN {{rate}}%",
        "next_details": "Lanjut: Detail Penawaran",
        "next_items": "Lanjut: Item Layanan",
        "next_review": "Lanjut: Tinjau",
        "btn_cancel": "Batal",
        "btn_draft": "Simpan Draf",
        "btn_send": "Kirim Penawaran",
        "notify_created": "Penawaran dibuat",
        "notify_sent": "{{code}} tersimpan & terkirim.",
        "notify_draft": "{{code}} disimpan sebagai Draf.",
        "new_customer": "Tambah pelanggan baru →",
        "no_boats": "Pelanggan ini belum punya kapal.",
        "add_boat": "Tambah kapal →",
        "required_badge": "Wajib",
        "optional_badge": "Opsional",
        "done_badge": "Selesai"
      },
      "invoice_new": {
        "title": "Buat Faktur",
        "subtitle": "Faktur dibuat sebagai Pro Forma — finalisasi dan kirim di halaman detail",
        "proforma_notice": "Faktur baru selalu dimulai sebagai Pro Forma. Setelah disimpan, buka detail faktur untuk memfinalisasi, mengirim ke pelanggan, atau mencatat pembayaran.",
        "step_customer": "Pelanggan",
        "step_boat": "Kapal",
        "step_details": "Detail Faktur",
        "step_recipient": "Penerima Tagihan",
        "step_items": "Item Tagihan",
        "label_customer": "Pilih Pelanggan",
        "label_boat": "Kapal Pelanggan",
        "placeholder_customer": "Cari nama atau email pelanggan…",
        "placeholder_boat": "Pilih kapal…",
        "due_date": "Jatuh Tempo",
        "due_days_left": "Jatuh tempo {{n}} hari lagi · {{date}}",
        "due_today": "Jatuh tempo hari ini · {{date}}",
        "due_passed": "Tanggal jatuh tempo sudah lewat · {{date}}",
        "tax_rate": "Tarif Pajak (%)",
        "tax_free": "0% — Bebas Pajak",
        "tax_ppn": "11% — PPN",
        "notes_label": "Catatan (opsional)",
        "notes_desc": "Catatan internal atau instruksi pembayaran untuk pelanggan",
        "notes_placeholder": "Contoh: Transfer ke BCA 1234567890 a.n. Marina Bali...",
        "recipient_title": "Penerima Tagihan",
        "recipient_subtitle": "Kepada siapa faktur ini ditagihkan?",
        "recipient_same": "Gunakan data pelanggan yang dipilih",
        "recipient_same_desc": "Data nama, email, dan alamat akan diambil dari profil pelanggan",
        "field_name": "Nama",
        "field_email": "Email",
        "field_company": "Nama Perusahaan",
        "field_npwp": "NPWP",
        "field_address": "Alamat Penagihan",
        "items_title": "Item Tagihan",
        "items_subtitle": "Layanan dan biaya yang ditagihkan dalam faktur ini.",
        "items_hint": "Tambahkan minimal satu item dengan harga untuk bisa menyimpan faktur.",
        "summary_title": "Ringkasan Faktur",
        "field_customer": "Pelanggan",
        "field_boat": "Kapal",
        "field_recipient": "Penerima",
        "field_due": "Jatuh Tempo",
        "no_customer": "— belum dipilih",
        "subtotal": "Subtotal",
        "tax": "PPN {{rate}}%",
        "btn_cancel": "Batal",
        "btn_create": "Buat Faktur",
        "notify_created": "Faktur dibuat",
        "notify_proforma": "{{code}} berhasil dibuat sebagai Pro Forma."
      }
    },
    "accounts": {
      "customers": {
        "title": "Pelanggan",
        "subtitle": "Daftar pelanggan terdaftar di marina",
        "btn_new": "+ Tambah Pelanggan",
        "placeholder": "Cari nama, email pelanggan…",
        "col_customer": "Pelanggan",
        "col_category": "Kategori",
        "col_country": "Negara",
        "col_boats": "Kapal",
        "col_bookings": "Booking",
        "col_status": "Status",
        "col_actions": "Aksi",
        "badge_in_marina": "Berlabuh",
        "empty": "Belum ada pelanggan terdaftar"
      },
      "boats": {
        "title": "Kapal",
        "subtitle": "Armada kapal yang terdaftar di marina",
        "btn_new": "+ Tambah Kapal",
        "placeholder": "Cari nama atau tipe kapal…",
        "col_boat": "Kapal",
        "col_owner": "Pemilik",
        "col_dimensions": "Dimensi",
        "col_location": "Lokasi",
        "col_status": "Status",
        "col_actions": "Aksi",
        "empty": "Belum ada kapal terdaftar",
        "in_marina": "Di Marina",
        "at_sea": "Di Laut",
        "unknown": "Tidak Diketahui"
      },
      "contracts": {
        "title": "Kontrak",
        "subtitle": "Kelola kontrak berlabuh pelanggan",
        "btn_new": "+ Buat Kontrak",
        "placeholder": "Cari kontrak…",
        "col_code": "Kode",
        "col_customer": "Pelanggan",
        "col_boat": "Kapal",
        "col_berth": "Berth",
        "col_duration": "Durasi",
        "col_value": "Nilai Total",
        "col_status": "Status",
        "tab_all": "Semua",
        "tab_draft": "Draf",
        "tab_prepared": "Siap",
        "tab_review": "Ditinjau",
        "tab_active": "Aktif",
        "tab_expired": "Kedaluwarsa",
        "tab_terminated": "Diakhiri",
        "empty": "Belum Ada Kontrak",
        "duration_months": "{{n}} bln",
        "duration_days": "{{n}} hari",
        "ai_draft_button": "AI: Susun faktur berikutnya",
        "ai_draft_title": "Susun faktur dengan AI",
        "ai_draft_loading": "AI sedang menyusun faktur — biasanya ~5 detik…",
        "ai_draft_subtitle": "Tinjau baris item yang disarankan AI di bawah. Anda dapat mengedit semuanya sebelum membuat faktur.",
        "ai_draft_period_this": "Bulan ini",
        "ai_draft_period_next": "Bulan depan",
        "ai_draft_subtotal": "Subtotal",
        "ai_draft_tax": "Pajak ({{rate}}%)",
        "ai_draft_total": "Total",
        "ai_draft_due_date": "Jatuh tempo",
        "ai_draft_create": "Buat faktur konsep",
        "ai_draft_cancel": "Batal",
        "ai_draft_failed": "AI tidak dapat menyusun faktur ini. Coba lagi atau buat manual.",
        "ai_draft_disabled": "AI belum dikonfigurasi di server. Mintalah admin untuk mengaktifkan proxy.",
        "ai_draft_period_label": "Periode penagihan",
        "ai_draft_col_desc": "Deskripsi",
        "ai_draft_col_qty": "Jml",
        "ai_draft_col_price": "Harga satuan",
        "ai_draft_col_amount": "Jumlah",
        "ai_draft_success": "Faktur konsep dibuat",
        "ai_draft_only_active": "Draf AI hanya tersedia untuk kontrak aktif",
        "new_title": "Buat Kontrak",
        "new_subtitle": "Kontrak berlabuh baru untuk pelanggan",
        "step1": "Pilih Pelanggan",
        "step2": "Detail Kontrak",
        "step3": "Item Kontrak",
        "step4": "Dokumen & Catatan",
        "step5": "Tinjau Perjanjian",
        "next_step2": "Lanjut: Detail Kontrak",
        "next_step3": "Lanjut: Item Kontrak",
        "next_step4": "Lanjut: Dokumen & Catatan",
        "next_step5": "Lanjut: Tinjau",
        "btn_cancel": "Batal",
        "btn_back": "Kembali",
        "btn_draft": "Simpan Draf",
        "btn_prepared": "Tandai Siap",
        "type_weekly": "Mingguan",
        "type_monthly": "Bulanan",
        "type_seasonal": "Musiman",
        "type_annual": "Tahunan",
        "review_parties": "Para Pihak",
        "review_period": "Periode",
        "review_items": "Item",
        "review_signature": "Tanda Tangan",
        "notify_created": "Kontrak dibuat",
        "notify_prepared": "{{code}} ditandai Siap",
        "notify_draft": "{{code}} disimpan sebagai Draf."
      }
    },
    "facility": {
      "tasks": {
        "title": "Tugas",
        "subtitle": "Tugas operasional staf marina",
        "btn_new": "+ Buat Tugas",
        "placeholder": "Cari judul tugas…",
        "col_title": "Judul",
        "col_category": "Kategori",
        "col_priority": "Prioritas",
        "col_assigned": "Ditugaskan ke",
        "col_deadline": "Batas Waktu",
        "col_status": "Status",
        "col_actions": "Aksi",
        "tab_list": "Daftar",
        "tab_calendar": "Kalender",
        "empty": "Belum ada penugasan",
        "overdue": "Terlambat",
        "cat_customer_support": "Layanan Pelanggan",
        "cat_maintenance": "Pemeliharaan",
        "cat_cleaning": "Kebersihan",
        "cat_admin": "Administrasi",
        "cat_security": "Keamanan",
        "cat_other": "Lainnya",
        "cal_prev": "Bulan sebelumnya",
        "cal_next": "Bulan berikutnya",
        "cal_today": "Hari ini",
        "cal_more": "lainnya",
        "cal_no_tasks": "Tidak ada tugas di hari ini.",
        "cal_no_deadlines": "Belum ada tugas dengan tenggat waktu.",
        "priority_urgent": "Mendesak",
        "priority_high": "Tinggi",
        "priority_medium": "Sedang",
        "priority_low": "Rendah"
      },
      "inventory": {
        "title": "Inventaris",
        "subtitle": "Stok barang dan perlengkapan marina",
        "btn_new": "+ Tambah Item",
        "placeholder": "Cari nama item…",
        "col_item": "Item",
        "col_category": "Kategori",
        "col_stock": "Stok",
        "col_status": "Status",
        "col_updated": "Diperbarui",
        "col_actions": "Aksi",
        "tab_all": "Semua",
        "tab_out": "Habis",
        "tab_low": "Rendah",
        "alert_out": "{{n}} item habis",
        "alert_low": "{{n}} item stok rendah",
        "empty": "Belum ada item inventaris"
      }
    },
    "settings": {
      "index": {
        "title": "Pengaturan",
        "subtitle": "Konfigurasi workspace marina Anda",
        "card_marina": "Informasi Marina",
        "card_marina_desc": "Nama marina, alamat, mata uang, zona waktu, pajak, kontak dukungan.",
        "card_berths": "Manajemen Berth",
        "card_berths_desc": "Kelola pontoon dan berth — dimensi, harga, layanan, posisi di peta.",
        "card_audit": "Log Audit",
        "card_audit_desc": "Semua tindakan pengguna: booking, faktur, perubahan status — untuk kepatuhan.",
        "card_staff": "Staf & Peran",
        "card_staff_desc": "Undang anggota tim, ubah peran, kelola izin akses.",
        "card_email": "Template Email",
        "card_email_desc": "Kustomisasi email penawaran, faktur, dan konfirmasi booking.",
        "card_notifications": "Notifikasi",
        "card_notifications_desc": "Preferensi notifikasi per-event (in-app, email, SMS).",
        "card_security": "Keamanan",
        "card_security_desc": "API keys, manajemen sesi, dokumen kepatuhan UU PDP.",
        "badge_active": "Aktif",
        "badge_soon": "Segera"
      },
      "marina": {
        "title": "Informasi Marina",
        "subtitle": "Nama, lokasi, zona waktu, mata uang, dan kontak dukungan",
        "section_identity": "Identitas Marina",
        "section_location": "Lokasi & Regional",
        "section_contact": "Kontak Dukungan",
        "field_name": "Nama Marina",
        "field_name_desc": "Nama resmi yang tampil di faktur, penawaran, dan kontrak",
        "field_name_placeholder": "Benoa Marina Bali",
        "field_logo": "URL Logo",
        "field_logo_desc": "PNG/SVG transparan, lebar min. 200px. Muncul di header dokumen.",
        "field_logo_placeholder": "https://cdn.example.com/logo.png",
        "preview_label": "Tampilan di header faktur & penawaran:",
        "field_address": "Alamat",
        "field_address_placeholder": "Jl. Raya Benoa, Kuta Selatan",
        "field_city": "Kota",
        "field_city_placeholder": "Badung",
        "field_country": "Negara",
        "field_timezone": "Zona Waktu",
        "field_currency": "Mata Uang",
        "field_tax": "Tarif Pajak Default (%)",
        "field_tax_desc": "Digunakan sebagai nilai awal saat membuat penawaran atau faktur baru",
        "field_email": "Email Dukungan",
        "field_email_placeholder": "support@marina.id",
        "field_email_desc": "Tampil di footer dokumen dan email otomatis",
        "field_phone": "Telepon / WhatsApp",
        "field_phone_placeholder": "+62 812 3456 7890",
        "field_phone_desc": "Nomor yang dihubungi pelanggan",
        "loading": "Memuat…",
        "last_saved": "Terakhir disimpan {{datetime}}",
        "btn_save": "Simpan Perubahan",
        "notify_saved": "Tersimpan",
        "notify_saved_msg": "Informasi marina berhasil diperbarui"
      },
      "berths": {
        "title": "Manajemen Berth",
        "subtitle": "Kelola pontoon dan berth — dimensi, utilitas, tarif, dan posisi peta",
        "pontoon_section": "Pontoon ({{n}})",
        "berth_section": "Berth",
        "btn_add_pontoon": "+ Tambah Pontoon",
        "btn_add_berth": "+ Tambah Berth",
        "filter_all": "Semua",
        "stat_available": "{{n}} tersedia",
        "stat_occupied": "{{n}} terisi",
        "stat_maintenance": "{{n}} maintenance",
        "col_code": "Kode",
        "col_name": "Nama",
        "col_berths": "Berth",
        "col_sort": "Urutan",
        "col_dimensions": "Dimensi Maks",
        "col_utilities": "Utilitas",
        "col_rate": "Tarif Harian",
        "col_status": "Status",
        "empty_pontoon": "Belum ada pontoon — tambahkan pontoon terlebih dahulu sebelum membuat berth",
        "empty_berth": "Belum ada berth",
        "empty_berth_filter": "Belum ada berth di pontoon ini",
        "modal_add_pontoon": "Tambah Pontoon",
        "modal_edit_pontoon": "Edit Pontoon {{code}}",
        "modal_add_berth": "Tambah Berth",
        "modal_edit_berth": "Edit Berth {{code}}",
        "pontoon_code_label": "Kode",
        "pontoon_code_desc": "Huruf tunggal atau kombinasi (A, B, VIP)",
        "pontoon_sort_label": "Urutan Tampil",
        "pontoon_sort_desc": "Angka lebih kecil = tampil lebih awal",
        "pontoon_name_label": "Nama",
        "pontoon_name_desc": "Nama deskriptif opsional",
        "berth_code_label": "Kode Berth",
        "berth_code_desc": "Unik per marina (mis. A-1, B-03, VIP-1)",
        "berth_number_label": "Nomor",
        "berth_pontoon_label": "Pontoon",
        "section_dimensions": "Dimensi (meter)",
        "berth_loa_label": "Max LOA",
        "berth_loa_desc": "Panjang total kapal maks",
        "berth_beam_label": "Max Beam",
        "berth_beam_desc": "Lebar kapal maks",
        "berth_draft_label": "Max Draft",
        "berth_draft_desc": "Sarat air kapal maks",
        "berth_depth_label": "Kedalaman Air",
        "berth_depth_desc": "Kedalaman aktual di berth ini",
        "section_utilities": "Utilitas",
        "berth_water_label": "Suplai Air",
        "berth_water_desc": "Sambungan air bersih tersedia",
        "berth_electric_label": "Listrik / Shore Power",
        "berth_electric_desc": "Sambungan listrik tersedia",
        "berth_amperage_label": "Amperage",
        "section_rates": "Tarif",
        "berth_daily_label": "Harian (IDR)",
        "berth_daily_desc": "Dasar perhitungan booking",
        "berth_monthly_label": "Bulanan (IDR)",
        "berth_monthly_desc": "Opsional",
        "berth_yearly_label": "Tahunan (IDR)",
        "berth_yearly_desc": "Opsional",
        "section_status": "Status & Catatan",
        "berth_status_label": "Status Berth",
        "berth_notes_label": "Catatan Internal",
        "berth_notes_desc": "Informasi tambahan untuk staf (tidak ditampilkan ke pelanggan)",
        "berth_notes_placeholder": "Mis: berth sudut, akses crane terbatas...",
        "confirm_del_pontoon_title": "Hapus Pontoon",
        "confirm_del_pontoon_msg": "Hapus pontoon {{code}}? Pontoon harus kosong (tidak punya berth).",
        "confirm_del_berth_title": "Hapus Berth",
        "confirm_del_berth_msg": "Hapus berth {{code}}? Tidak bisa dihapus jika masih ada booking atau kontrak aktif.",
        "btn_save": "Simpan",
        "btn_create": "Buat",
        "notify_pontoon_created": "Pontoon dibuat",
        "notify_pontoon_updated": "Pontoon diperbarui",
        "notify_pontoon_deleted": "Pontoon dihapus",
        "notify_berth_created": "Berth dibuat",
        "notify_berth_updated": "Berth diperbarui",
        "notify_berth_deleted": "Berth dihapus",
        "err_pontoon_berths": "Pontoon mungkin masih punya berth",
        "err_berth_bookings": "Berth mungkin masih punya booking"
      },
      "audit": {
        "title": "Log Audit",
        "subtitle": "Riwayat semua tindakan pengguna — booking, faktur, perubahan status",
        "placeholder": "Filter aksi (mis. BOOKING, LOGIN)…",
        "col_time": "Waktu",
        "col_user": "Pengguna",
        "col_action": "Aksi",
        "col_detail": "Detail",
        "col_ip": "IP",
        "empty": "Belum ada entri audit"
      }
    },
    "utilities": {
      "title": "Utilitas",
      "subtitle": "Manajemen air & listrik per berth via integrasi Plus Marine",
      "integration_title": "Integrasi Plus Marine",
      "integration_body1": "Integrasi metering & billing utilitas dengan Plus Marine akan diaktifkan di fase berikutnya.",
      "integration_body2": "Untuk mendaftar, hubungi Plus Marine atau tim marina office Anda.",
      "integration_body3": "Fase berikutnya: grafik konsumsi, auto-generate invoice utilitas, alert ambang batas.",
      "coming_soon_title": "Integrasi Plus Marine",
      "coming_soon_body": "Fitur monitoring utilitas (air, listrik) per berth sedang dalam pengembangan.",
      "login_title": "Masuk",
      "login_subtitle": "Belum punya kredensial? Hubungi tim marina office Anda",
      "email_label": "E-mail",
      "email_placeholder": "alamat@email.com",
      "password_label": "Kata Sandi",
      "forgot_password": "Lupa kata sandi?",
      "btn_login": "MASUK",
      "footer_credit": "Didukung oleh Plus Marine — penyedia utilitas untuk marina di seluruh Indonesia.",
      "modal_title": "Integrasi segera hadir"
    }
  },
  "component": {
    "table": {
      "empty": "Tidak ada data",
      "showing": "{{first}}–{{last}} dari {{total}} data"
    },
    "booking_table": {
      "col_customer": "Pelanggan",
      "col_boat": "Kapal",
      "col_period": "Periode",
      "col_channel": "Saluran",
      "col_status": "Status",
      "col_code": "Booking",
      "created_prefix": "dibuat"
    },
    "notification": {
      "title": "Notifikasi",
      "mark_all": "Tandai semua dibaca",
      "empty": "Belum ada notifikasi"
    }
  },
  "portal": {
    "welcome": "Selamat datang di Portal Pelanggan",
    "my_bookings": "Reservasi Saya",
    "my_invoices": "Invoice Saya",
    "upcoming_reservations": "Reservasi Mendatang",
    "no_reservations": "Tidak ada reservasi mendatang",
    "no_invoices": "Belum ada invoice",
    "profile": "Profil"
  }
}
